// import external modules
import React from 'react';
import { Route } from 'react-router-dom';

// import internal(own) modules
import NavbarOnlyLayout from '../layouts/NavbarOnlyLayout';

const NavbarOnlyRoutes = ({ render, ...rest }) => {
  // console.log('this is full page layout');
  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <NavbarOnlyLayout>{render(matchProps)}</NavbarOnlyLayout>
      )}
    />
  );
};

export default NavbarOnlyRoutes;
